import {buildFormServerCall} from '../../services/formService';
import {getStateXml, getCompressedData} from '../../../_shared/GWTBridge/invoke/server';
import {writeLog} from '../../../_shared/GWTBridge/invoke/common';

export function applySearch(idx: string) {
    const methodName = 'FormQueryDlgApply';
    const reason = `Execute Query - ${idx}`;
    const statexml = getStateXml();
    const parameters = {statexml: [statexml], query: [idx]};
    writeLog(`${reason} (${methodName})`, '');
    return buildFormServerCall(methodName, parameters, reason, true);
}

export function processSearchDesign(json) {
    const methodName = 'FormQueryDlgDesign';
    const reason = 'Design Query';
    const statexml = getStateXml();
    const xml = getCompressedData(json);
    const parameters = {statexml: [statexml], xml: [xml.compressed]};
    writeLog(`${reason} (${methodName})`, xml.original);
    return buildFormServerCall(methodName, parameters, reason, true);
}

export function getAllSearchesFilters() {
    const methodName = 'FormQueryDlgStart';
    const reason = 'Start Query Dialog';
    const statexml = getStateXml();
    const parameters = {statexml: [statexml]};
    writeLog(`${reason} (${methodName})`, '');
    return buildFormServerCall(methodName, parameters, reason, true);
}

export function generatorOpenSearchField(field, searchQuery) {
    const methodName = 'FormQueryDlgChoose';
    const reason = 'Query Diolog Choose';
    const statexml = getStateXml();
    const parameters = {
        statexml: [statexml],
        field: [field],
        mode: ['0'],
        editvalue: [searchQuery]
    };
    writeLog(`${reason} (${methodName})`, `field: ${field}, editvalue: ${searchQuery}`);
    return buildFormServerCall(methodName, parameters, reason, false);
}

export function generatorSearchFieldAction(id, action, searchQuery) {
    const methodName = 'FormAlertSearch';
    const reason = 'Query Diolog Search';
    const statexml = getStateXml();
    const parameters = {
        statexml: [statexml],
        id: [id],
        mode: [action.toString()],
        editvalue: [searchQuery]
    };
    writeLog(
        `${reason} (${methodName})`,
        `id: ${id}, mode: ${action.toString()}, editvalue: ${searchQuery}`
    );
    return buildFormServerCall(methodName, parameters, reason, false);
}

export function generatorSearchNextPage(id, page, searchQuery) {
    const methodName = 'FormAlertSearchPage';
    const reason = 'Query Diolog Search Scroll';
    const statexml = getStateXml();
    const parameters = {
        statexml: [statexml],
        id: [id],
        page: [page.toString()],
        editvalue: [searchQuery]
    };
    writeLog(
        `${reason} (${methodName})`,
        `id: ${id}, mode: ${page.toString()}, editvalue: ${searchQuery}`
    );
    return buildFormServerCall(methodName, parameters, reason, false);
}
